export const PROVIDER_GAMES_QUERY = `
query ProviderGames($site: String!, $menuItemFilter: MenuItemFilter!, $gameFilter: GameAvailabilityFilter!) {
  casinoGameInventory {
    gameProvidersWithGames(site: $site, gameFilter: $gameFilter, menuItemFilter: $menuItemFilter) {
      name
      handle
      games {
        handle
        href
        id
        name
        thumbUrlTab
        volatility
        width
        thumbUrl
        thumbUrlMob
        provider { id name handle }
        category { id name }
        menuItem(section: 1) { handle name }
        isNew
        isFeatured
      }
    }
  }
}
`;
